import React, { useRef } from 'react'
import { Link } from "react-router-dom";
import { Pane, Text, TextInput, Button, EyeOpenIcon, EyeOffIcon } from 'evergreen-ui'
import { APIContext } from '../Api';

import './signup.scss'

import img from '../assets/logo_transparent_background.png';
import loginhero from '../assets/loginhero.jpg';


export function AuthFrame(props) {

    return <Pane display={"flex"} flexDirection={"row"} background={"blueTint"} height={"100%"}>
        <Pane style={{
            maxWidth: "60%",
            display: "flex",
            alignItems: "center"
        }}
            display={"flex"} justifyContent={"center"} flex={"1"} margin={16} paddingLeft={"2%"}>
            <img style={{ borderRadius: "50px" }} src={loginhero} />

        </Pane>
        <Pane display={"flex"} flex={"2"} justifyContent={"center"} flexDirection={"column"} margin={16} paddingRight={"10%"} >
            <div className="signuparea">
                <Pane display={"flex"} flexDirection={"column"} alignItems={"center"} >
                    <img style={{ maxWidth: '70%', margin: 'auto' }} src={img} />
                </Pane>

                <Pane

                    display={"flex"} justifyContent={"center"} flexDirection={"column"} >
                    
                        {props.children}
         
                </Pane></div>
        </Pane>


    </Pane >

}